module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-color-picker', _vm._g(_vm._b({}, 'el-color-picker', _vm.$attrs, false), _vm.$listeners))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f6d6e91a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/colorPicker/rtColorPicker.vue
// module id = 2237
// module chunks = 137